import PaysonicNoise from "@assets/noise/paysonic-noise.svg";
import TyltNoise from "@assets/noise/tylt-noise.svg";

const isPaysonic =
  window.location.hostname === "insights.paysonic.network" ? true : false;

export const SignupNoise = isPaysonic ? PaysonicNoise : TyltNoise;
